<template>
    <div>
        <el-dialog :title="$t('editAdvertCrop')"
                   :visible.sync="dialogVisible"
                   :close-on-click-modal="false"
                   @close="dialogClose"
                   center
                   custom-class="medium-dialog">
            <div class="content">
                <div class="picture">
                    <a href="javascript:void(0);" class="clickable" @click="editCropDialog = true">
                        <img :src="cropObj.url" alt="">
                    </a>
                </div>
                <el-form :model="formData"
                         :rules="rules"
                         ref="ruleForm"
                         label-width="110px">
                    <el-form-item :label="$t('goodsName')"
                                  prop="name">
                        <el-input v-model="formData.name"
                                  autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('originPrice')"
                                  prop="originalPrice">
                        <el-input v-model="formData.originalPrice"
                                  autocomplete="off" v-input-float>
                            <template slot="append">€</template>
                        </el-input>
                    </el-form-item>
                    <el-form-item :label="$t('marketPrice')"
                                  prop="currentPrice">
                        <el-input v-model="formData.currentPrice"
                                  autocomplete="off" v-input-float>
                            <template slot="append">€</template>
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer"
                 class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">{{ $t('cancel') }}</el-button>
                <el-button type="primary"
                           size="mini"
                           :disabled="disabled"
                           @click="submitForm('ruleForm')">{{ $t('confirm') }}</el-button>
            </div>
        </el-dialog>
        <!-- 编辑切图 -->
        <EditCrop
            :parent-dialog="editCropDialog"
            @parent-update="updateCrop"
            @parent-close="editCropDialog = false"/>
    </div>
    
</template>

<script>
import {
    queryAdvertCropperDetails,
    updateAdvertCropper,
} from "@/api/modules/api";
import {formatNum} from "@/utils/common";
import EditCrop from "@/components/advert/cropper/EditCrop";
export default {
    name: 'Edit',
    props: {
        parentDialog: {
            type: Boolean,
            default: true
        },
        parentId: {
            type: String,
            default: ''
        },
    },
    components: {
        EditCrop
    },
    data () {
        return {
            dialogVisible: false,
            cropObj: {
                url: '',   // 切图url
                lengthCoordinate: 0,   // 切图左上角相对底图x坐标
                highCoordinate: 0,     // 切图左上角相对底图y坐标
                lengthProportion: 0,   // 切图与底图宽比
                highProportion: 0,     // 切图与底图高比
            },
            formData: {
                name: '',
                originalPrice: '',
                currentPrice: ''
            },
            rules: {
                name: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                originalPrice: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
                currentPrice: [{ required: true, message: this.$t('pleaseInputHint'), trigger: 'blur' }],
            },
            disabled: false,
            editCropDialog: false
        }
    },
    created () { },
    mounted () { },
    watch: {
        parentDialog (val) {
            if (val) {
                this.initData()
            }
        },
    },
    methods: {
        // 初始化数据
        initData () {
            this.dialogVisible = true
            this.cropObj = {
                url: '',
                lengthCoordinate: 0,
                highCoordinate: 0,
                lengthProportion: 0,
                highProportion: 0,
            }
            // 获取详情
            this.getDetails()
        },
    
        // 获取详情
        getDetails () {
            queryAdvertCropperDetails(this.parentId).then((res) => {
                if (Number(res.code) === 20000) {
                    let resData = res.data
                    this.cropObj = {
                        url: resData.image,
                        lengthCoordinate: resData.lengthCoordinate,
                        highCoordinate: resData.highCoordinate,
                        lengthProportion: resData.lengthProportion,
                        highProportion: resData.highProportion,
                    }
                    this.formData = {
                        name: resData.name,
                        originalPrice: resData.originalPrice,
                        currentPrice: resData.currentPrice
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            });
        },
        
        // 更新切图
        updateCrop (obj) {
            this.cropObj = obj
        },
        
        // 验证表单
        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendRequest()
                } else {
                    return false
                }
            })
        },
        // 重置表单
        resetForm (formName) {
            this.$refs[formName].resetFields()
        },
        // 提交
        sendRequest () {
            if (!this.cropObj.url) {
                this.$message({
                    showClose: true,
                    message: this.$t('uploadCropHint'),
                    type: 'warning'
                })
                return
            }
            // 折扣百分比
            let discountProportion = (this.formData.currentPrice / this.formData.originalPrice) * 100
            discountProportion = formatNum(discountProportion, 2)
            const params = {
                showcaseItemId: this.advertPaperId,
                showcaseId: this.advertBookId,
                id: this.parentId,
                name: this.formData.name,
                originalPrice: this.formData.originalPrice,
                currentPrice: this.formData.currentPrice,
                discountProportion,
                image: this.cropObj.url,
                lengthCoordinate: this.cropObj.lengthCoordinate,
                highCoordinate: this.cropObj.highCoordinate,
                lengthProportion: this.cropObj.lengthProportion,
                highProportion: this.cropObj.highProportion,
            }
            this.disabled = true;
            updateAdvertCropper(params).then((res) => {
                if (Number(res.code) === 20000) {
                    this.dialogVisible = false
                    this.$emit('parent-update')
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                this.$message.error(err);
            }).finally(() => {
                this.disabled = false;
            })
        },
        // 关闭弹窗
        dialogClose () {
            // 重置表单
            this.resetForm('ruleForm')
            this.$emit('parent-close')
        }
    },
}
</script>

<style scoped lang="scss">
.content{
    .picture{
        width: 100%;
        height: 150px;
        display: flex;
        justify-content: center;
        .clickable{
            display: inline-block;
            width: 120px;
            height: 120px;
            img{
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }
}
</style>
